module.exports = __webpack_public_path__ + "img/download.9511190b.svg";